import styled from 'styled-components'

const AsideStyle = styled.aside`
  grid-area: aside;
`
export default AsideStyle
